export const TOKEN_LIST_ENDPOINT =
  'https://token-api.metaswap.codefi.network/tokens/1';
